
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import LiveOfferDealsComponent from '@/components/LiveOfferDealsComponent.vue';                       // @ is an alias to /src
import MostActiveDealsOffersComponent from '@/components/MostActiveOffersComponent.vue';                       // @ is an alias to /src
import HighestSpreadsComponent from '@/components/HighestSpreadsComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { TokenUser } from '@/TokenUser'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

export type modeType = 'mostActive' | 'highestSpread' | 'live'
@Component({
  name: 'Offers',
  components: { LiveOfferDealsComponent, MostActiveDealsOffersComponent, HighestSpreadsComponent, ModalWrapperComponent }
})

export default class Offers extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public mode: modeType = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // private, non-reactive member variables

  @Watch('mode')
  private async modeChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Offers.modeChanged() ${this.mode}`)

    this.$router.replace(`/offers/${this.mode}`).catch(() => {})
  }

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`Offers.pathChanged() ${this.$route.path}`)

    // use mode from URL if it exists
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode as modeType
    } else {
      this.mode = 'mostActive'
    }
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    if (this.user) utils_tracker.identify(this.user)

    await this.pathChanged()

    this.$router.replace(`/offers/${this.mode}`).catch(() => {})

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

}
